import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-cost-center-detail',
  templateUrl: './cost-center-detail.component.html',
  styleUrls: ['./cost-center-detail.component.scss']
})
export class CostCenterDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  listUsers: any = [];
  listSocieties: any = [];
  listApprovers: any;
  info: any;
  editId: any;
  new: any = {};
  EsCentroDeCosto: any;
  txtTitle: any;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private provService: ProvidersService, private groupService: GroupService, public dialogRef: MatDialogRef<CostCenterDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.userId = this.data.userId;
    this.userToken = this.data.userToken;
    this.listSocieties = this.data.listSocieties;
    this.listApprovers = this.data.listApprovers;
    this.info = this.data.info;
    this.EsCentroDeCosto = this.data.EsCentroDeCosto;

    console.log(this.type);
    

    if(this.type === 'new'){
      this.SociedadActive();
      if(this.EsCentroDeCosto){
        this.textButton = 'NEWCOSTCENTER';
        this.txtTitle = 'Agregar centro de costo';
      }else{
        this.textButton = 'NEWORDERINTERN';
        this.txtTitle = 'Agregar orden interno';
      }
    }

    if(this.type === 'assign'){
      this.getListUsers();
      console.log(this.info);
      this.editId = this.data.id;
      this.textButton = 'ASSIGNCC';
      this.txtTitle = 'Asignar centro de costo'
    }

    if(this.type === 'users'){
      console.log(this.info);
      this.editId = this.data.id;
      this.textButton = 'ADMINAUTH';
      this.txtTitle = 'Administrar autorizadores';
      this.listUsers = this.info.lsUsuariosAsignados;
    }

    
  }

  ngOnInit() {
  }

  addnew(){
    console.log(this.new);
    if(!this.new.ClaveCC || !this.new.IdSociedad){
      this.toastr.error('Favor agregar la información', this.txtTitle);
      return;
    }
    this.new.EsCentroDeCosto = this.EsCentroDeCosto;
    this.loadBtn = true;
    this.provService.costCenterAddClave(this.new, this.userToken).then((data) => {
      console.log(data);
      this.loadBtn = false;
      if(data['estatusProceso']){
        this.toastr.success('Centro de costo agregado correctamente', this.txtTitle);
        this.dialogRef.close({lsClaves: data['lsClaves']});
      }else{
        this.toastr.error(data['lsMensajes'][0].value, this.txtTitle);
        return;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), this.txtTitle);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  assign(){
    if(!this.new.user){
      this.toastr.error('Favor ade seleccionar al usuario', this.txtTitle);
      return;
    }

    const params = {IdClave: this.info.idClave, IdUsuario: this.new.user, EsCentroDeCosto: this.EsCentroDeCosto};
    this.loadBtn = true;
    this.provService.costCenterAssignClave(params, this.userToken).then((data) => {
      console.log(data);
      this.loadBtn = false;
      if(data['estatusProceso']){
        this.toastr.success('Centro de costo asignado correctamente', this.txtTitle);
        this.dialogRef.close({lsClaves: data['lsClaves']});
      }else{
        this.toastr.error(data['lsMensajes'][0].value, this.txtTitle);
        return;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), this.txtTitle);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  delete(idx){
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'delete', id: 13, button: 'Remover', title: 'Remover usuario', content: '¿Esta seguro de querer remover a este usuario como autorizador del centro de costos?', icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.loadBtn = true;
        const params = {IdClaveUsuario: this.listUsers[idx].idClaveUsuario, IdUsuarioModificacion: this.userId, EsCentroDeCosto: this.EsCentroDeCosto};
        this.provService.costCenterRemoveClave(params, this.userToken).then((data) => {
          console.log(data);
          this.loadBtn = false;
          if(data['estatusProceso']){
            this.toastr.success('Usuario eliminado del centro de costo correctamente', this.txtTitle);
            this.dialogRef.close({lsClaves: data['lsClaves']});
          }else{
            this.toastr.error(data['lsMensajes'][0].value, this.txtTitle);
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error(JSON.stringify(err), this.txtTitle);
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  onCloseConfirm(){
    /*if(!this.send.userAuth){
      this.toastr.error('Favor de seleccionar el usuario autorizador', 'Asignar usuario');
      return;
    }
    const params = {idUsuarioSAP: this.info.idAutorizadorSAP, idUsuarioPortal: this.send.userAuth};
    this.groupService.assignUserAuth(params, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['procesoCorrecto']){
        if(this.type === 'assign') {
          this.toastr.success('Usuario asignado correctamente', 'Asignar usuario');
        }else{
          this.toastr.success('Usuario reasignado correctamente', 'Reasignar usuario');
        }
        this.dialogRef.close({pendientesPorAsignar: data['pendientesPorAsignar'], usuariosAsignados: data['usuariosAsignados']});
      }else{
        this.toastr.error(data['lsMensajes'][0].value, 'Asignar usuario');
        return;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), 'Asignar usuario');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });*/
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  SociedadActive(){
    this.provService.getCentroCostoSociedad(this.userId, '123').then((res:any)=>{
      this.listSocieties = res.Entidades;
      
    });
  }

  getListUsers(){    
console.log('llegamos')
    this.provService.getUserAuthorizer('123').then((res:any)=>{
      this.listApprovers = res.Entidades;
      
    });
  }
}
